import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProductService } from '../../../service/product.service';

@Component({
  selector: 'app-modal-delete-product',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-delete-product.html',
  styleUrl: './modal-delete-product.scss'
})
export class ModalDeleteProduct implements OnInit {

  private productService = inject(ProductService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  loading = signal(false);
  success = signal(false);
  error = signal<string | null>(null);

  codigo = 0;

  ngOnInit(): void {
    // Obtiene el ID desde la URL: /delete-product/105
    this.codigo = Number(this.route.snapshot.paramMap.get('codigo'));
  }

  onConfirmDelete(): void {
    if (!this.codigo) return;

    this.loading.set(true);

    this.productService.delete(this.codigo).subscribe({
      next: () => {
        this.loading.set(false);
        this.success.set(true);
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al eliminar el producto.');
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/search-product']);
  }
}
